<template>
  <UtilHitCard
    type="listing"
    :layout="layout"
    :listing="compListingFromHit"
    :to="`/view/listing/${hit.slug}-${hit.objectID}`"
    :showStatusTags="showStatusTags"
    :canWatch="canWatch"
  />
</template>

<script>
  import {get} from 'lodash'
  import {listingType} from '@/lib/mapping'
  import CompanyModel from '@/lib/models/company'
  import UserModel from '@/lib/models/user'
  import UtilHitCard from '@/components/utils/UtilHitCard'

  export default {
  name: 'UtilSearchHit',
  components: {
    UtilHitCard
  },
  props: {
    hit: {
      type: Object,
      required: true
    },
    layout: {
      type: String,
      default: 'card',
      validator: prop => ['card', 'list'].includes(prop)
    },
    showStatusTags: Boolean,
    canWatch: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    // Map Agolia data to our expected listing model
    compListingFromHit() {
      return {
        ...this.hit,
        listingCode: this.hit.objectID,
        startTimestamp: this.hit.start,
        quantity: this.hit.quantityStart,
        title: this.hit.title,
        featureImageRef: this.hit.images && this.hit.images.length ? this.hit.images[0] : undefined,
        location: [this.compLocation],
        user: [
          new UserModel({
            ...this.hit.owner,
            firstName: this.hit.owner.name.split(' ').shift(),
            lastName: this.hit.owner.name.split(' ').pop(),
            subscriptionLevel: this.hit.owner.subscriptionLevel,
            subscriptionPlan: this.hit.owner.subscriptionPlan
          })
        ],
        company: [
          new CompanyModel({
            name: this.hit.owner.business
          })
        ],
        type: this.hit.tradeType === 'Wanted' ? listingType.WANTED : listingType.CLASSIFIED
      }
    },

    compLocation() {
      let location = { ...this.hit.location }

      // Algolia will give us a distance even if lat/lng is 0, so we need to filter that out
      if (get(this.hit, '_rankingInfo.geoDistance') && get(this.hit, '_rankingInfo.matchedGeoLocation.lat')) {
        location['milesAway'] = (this.hit._rankingInfo.geoDistance / 1609.344).toFixed(0)
      }

      return location
    }
  }
}
</script>
